module.exports = __webpack_public_path__ + "img/logo.0debea5f.svg";